import type { MediaLibraryItem } from "@/types";

/**
 * Demo media library. Stands in for the real /admin/media feed while the app
 * runs without a configured API. Every image is the SAME artwork the rest of the
 * demo data references, so the grid, details panel and folder filters all look
 * realistic. Real uploads replace these once the backend is connected.
 *
 * Static data only (no functions/imports) per the mocks contract.
 */
export const mediaLibraryItems: MediaLibraryItem[] = [
  {
    id: "1",
    url: "https://readdy.ai/api/search-image?query=Warm%20crispy%20Mysore%20masala%20dosa%20on%20a%20banana%20leaf%20with%20coconut%20chutney%20and%20filter%20coffee%2C%20rustic%20wooden%20table%2C%20soft%20natural%20light%2C%20appetizing%20food%20photography%2C%20warm%20tones&width=800&height=600&seq=myyp-biz-1&orientation=landscape",
    fileName: "mylari-dosa-hero.jpg",
    originalName: "IMG_2041.jpg",
    title: "Mylari Mane — masala dosa hero",
    altText: "Crispy Mysore masala dosa served on a banana leaf with chutney",
    caption: "Cover photo for the Mylari Mane listing.",
    folder: "listings",
    mime: "image/jpeg",
    size: "412 KB",
    sizeBytes: 421888,
    width: 800,
    height: 600,
    source: "owner",
    uploader: "Demo Owner",
    createdAt: "2026-10-04T09:12:00.000Z",
    updatedAt: "2026-10-04T09:12:00.000Z",
  },
  {
    id: "2",
    url: "https://readdy.ai/api/search-image?query=Elegant%20boutique%20hotel%20lobby%20with%20warm%20wood%20panels%2C%20brass%20lamps%20and%20marble%20floor%2C%20hospitality%20interior%20photography%2C%20amber%20and%20cream%20tones&width=800&height=600&seq=myyp-biz-2&orientation=landscape",
    fileName: "cauvery-grand-lobby.jpg",
    originalName: "lobby-final.jpg",
    title: "Cauvery Grand Hotel — lobby",
    altText: "Warm boutique hotel lobby with wood panels and brass lamps",
    caption: "",
    folder: "listings",
    mime: "image/jpeg",
    size: "638 KB",
    sizeBytes: 653312,
    width: 800,
    height: 600,
    source: "owner",
    uploader: "Demo Owner",
    createdAt: "2026-09-29T14:05:00.000Z",
    updatedAt: "2026-09-29T14:05:00.000Z",
  },
  {
    id: "3",
    url: "https://readdy.ai/api/search-image?query=Clean%20modern%20medical%20diagnostics%20lab%20interior%20with%20bright%20white%20surfaces%20and%20warm%20green%20accents%2C%20clinical%20healthcare%20photography%2C%20calm%20and%20professional&width=800&height=600&seq=myyp-biz-3&orientation=landscape",
    fileName: "sujatha-lab-interior.jpg",
    originalName: "lab-02.webp",
    title: "Sujatha Diagnostics — lab interior",
    altText: "Bright modern diagnostic laboratory interior",
    caption: "Used on the diagnostics listing gallery.",
    folder: "listings",
    mime: "image/webp",
    size: "355 KB",
    sizeBytes: 363520,
    width: 800,
    height: 600,
    source: "owner",
    uploader: "Demo Owner",
    createdAt: "2026-09-21T11:40:00.000Z",
    updatedAt: "2026-09-21T11:40:00.000Z",
  },
  {
    id: "4",
    url: "https://readdy.ai/api/search-image?query=Bright%20modern%20coaching%20classroom%20with%20wooden%20desks%2C%20green%20chalkboard%20and%20large%20windows%2C%20warm%20daylight%2C%20education%20photography&width=800&height=600&seq=myyp-biz-4&orientation=landscape",
    fileName: "akshara-classroom.jpg",
    originalName: "classroom.jpg",
    title: "Akshara Academy — classroom",
    altText: "Bright coaching classroom with wooden desks and large windows",
    caption: "",
    folder: "listings",
    mime: "image/jpeg",
    size: "301 KB",
    sizeBytes: 308224,
    width: 800,
    height: 600,
    source: "owner",
    uploader: "Demo Owner",
    createdAt: "2026-09-19T08:22:00.000Z",
    updatedAt: "2026-09-19T08:22:00.000Z",
  },
  {
    id: "5",
    url: "https://readdy.ai/api/search-image?query=Candid%20South%20Indian%20wedding%20moment%20with%20warm%20bokeh%20lights%20and%20floral%20decor%2C%20cinematic%20photography%2C%20golden%20and%20maroon%20tones&width=800&height=600&seq=myyp-biz-6&orientation=landscape",
    fileName: "sthree-wedding-candid.jpg",
    originalName: "DSC_8842.jpg",
    title: "Sthree Studio — wedding candid",
    altText: "Candid South Indian wedding moment with warm bokeh lights",
    caption: "Sample work for the wedding photography listing.",
    folder: "listings",
    mime: "image/jpeg",
    size: "712 KB",
    sizeBytes: 729088,
    width: 800,
    height: 600,
    source: "owner",
    uploader: "Demo Owner",
    createdAt: "2026-09-15T17:48:00.000Z",
    updatedAt: "2026-09-15T17:48:00.000Z",
  },
  {
    id: "6",
    url: "https://readdy.ai/api/search-image?query=Cozy%20plantation%20homestay%20veranda%20overlooking%20coffee%20hills%20in%20Coorg%2C%20wooden%20chairs%20and%20lanterns%2C%20misty%20green%20morning%2C%20warm%20inviting%20travel%20photography&width=800&height=600&seq=myyp-biz-7&orientation=landscape",
    fileName: "coorg-veranda.jpg",
    originalName: "coorg-veranda.jpg",
    title: "Coffee Trails Homestay — veranda",
    altText: "Plantation homestay veranda overlooking misty coffee hills in Coorg",
    caption: "",
    folder: "listings",
    mime: "image/jpeg",
    size: "486 KB",
    sizeBytes: 497664,
    width: 800,
    height: 600,
    source: "owner",
    uploader: "Demo Owner",
    createdAt: "2026-09-08T10:15:00.000Z",
    updatedAt: "2026-09-08T10:15:00.000Z",
  },
  {
    id: "7",
    url: "https://readdy.ai/api/search-image?query=Mysore%20Palace%20illuminated%20at%20dusk%20with%20golden%20lights%2C%20grand%20Indo-Saracenic%20architecture%2C%20dramatic%20twilight%20sky%2C%20editorial%20travel%20photography%2C%20rich%20amber%20tones&width=800&height=600&seq=myyp-spot-1&orientation=landscape",
    fileName: "mysore-palace-hero.jpg",
    originalName: "palace-dusk.jpg",
    title: "Mysore Palace at dusk",
    altText: "Mysore Palace illuminated at dusk with golden lights",
    caption: "Homepage hero — featured tourist spot.",
    folder: "library",
    mime: "image/jpeg",
    size: "524 KB",
    sizeBytes: 536576,
    width: 800,
    height: 600,
    source: "admin",
    uploader: "Administrator",
    createdAt: "2026-09-02T06:05:00.000Z",
    updatedAt: "2026-09-02T06:05:00.000Z",
  },
  {
    id: "8",
    url: "https://readdy.ai/api/search-image?query=Ancient%20hilltop%20temple%20gopuram%20on%20Chamundi%20Hills%20above%20Mysore%20at%20golden%20sunrise%2C%20hazy%20green%20valley%20below%2C%20travel%20photography&width=800&height=600&seq=myyp-spot-2&orientation=landscape",
    fileName: "chamundi-hills.jpg",
    originalName: "chamundi.jpg",
    title: "Chamundi Hills sunrise",
    altText: "Hilltop temple gopuram on Chamundi Hills at golden sunrise",
    caption: "",
    folder: "library",
    mime: "image/jpeg",
    size: "447 KB",
    sizeBytes: 457728,
    width: 800,
    height: 600,
    source: "admin",
    uploader: "Administrator",
    createdAt: "2026-08-30T05:40:00.000Z",
    updatedAt: "2026-08-30T05:40:00.000Z",
  },
  {
    id: "9",
    url: "https://readdy.ai/api/search-image?query=Symmetrical%20terraced%20gardens%20with%20fountains%20beside%20a%20dam%20at%20sunset%2C%20lush%20green%20hedges%2C%20warm%20golden%20light%2C%20travel%20photography&width=800&height=600&seq=myyp-spot-3&orientation=landscape",
    fileName: "brindavan-gardens.jpg",
    originalName: "brindavan.jpg",
    title: "Brindavan Gardens fountains",
    altText: "Terraced gardens with fountains beside the KRS dam at sunset",
    caption: "Tourist spots gallery.",
    folder: "library",
    mime: "image/jpeg",
    size: "498 KB",
    sizeBytes: 509952,
    width: 800,
    height: 600,
    source: "admin",
    uploader: "Administrator",
    createdAt: "2026-08-27T18:30:00.000Z",
    updatedAt: "2026-08-27T18:30:00.000Z",
  },
  {
    id: "10",
    url: "https://readdy.ai/api/search-image?query=Golden%20savanna%20grassland%20and%20forest%20edge%20in%20Bandipur%20National%20Park%20at%20sunrise%2C%20misty%20trees%2C%20wildlife%20travel%20photography&width=800&height=600&seq=myyp-spot-8&orientation=landscape",
    fileName: "bandipur-savanna.jpg",
    originalName: "bandipur-sunrise.jpg",
    title: "Bandipur at sunrise",
    altText: "Golden savanna grassland at the edge of Bandipur National Park",
    caption: "",
    folder: "library",
    mime: "image/jpeg",
    size: "531 KB",
    sizeBytes: 543744,
    width: 800,
    height: 600,
    source: "admin",
    uploader: "Administrator",
    createdAt: "2026-08-24T06:12:00.000Z",
    updatedAt: "2026-08-24T06:12:00.000Z",
  },
  {
    id: "11",
    url: "https://public.readdy.ai/ai/img_res/8b2e690d-6858-4713-8bc0-7beb77d60bf0.png",
    fileName: "site-logo.png",
    originalName: "Mysore-Yellow-Pages.png",
    title: "Site logo",
    altText: "Mysore Yellow Pages logo",
    caption: "Primary brand logo, used in the header and footer.",
    folder: "branding",
    mime: "image/png",
    size: "38 KB",
    sizeBytes: 38912,
    width: null,
    height: null,
    source: "admin",
    uploader: "Administrator",
    createdAt: "2026-08-20T12:00:00.000Z",
    updatedAt: "2026-08-20T12:00:00.000Z",
  },
  {
    id: "12",
    url: "https://public.readdy.ai/ai/img_res/edited_81f81b684a1146a3b8639a7e62c8e7a0_fc779e29.jpg",
    fileName: "favicon.jpg",
    originalName: "favicon.jpg",
    title: "Favicon",
    altText: "Mysore Yellow Pages favicon",
    caption: "Browser tab icon.",
    folder: "branding",
    mime: "image/jpeg",
    size: "12 KB",
    sizeBytes: 12288,
    width: 512,
    height: 512,
    source: "admin",
    uploader: "Administrator",
    createdAt: "2026-08-20T12:01:00.000Z",
    updatedAt: "2026-08-20T12:01:00.000Z",
  },
  {
    id: "13",
    url: "https://readdy.ai/api/search-image?query=Neat%20takeaway%20food%20packaging%20with%20South%20Indian%20breakfast%20items%20on%20a%20warm%20wooden%20surface%2C%20clean%20appetizing%20food%20photography%2C%20amber%20tones&width=800&height=600&seq=myyp-biz-13&orientation=landscape",
    fileName: "cloud-kitchen-pack.jpg",
    originalName: "pack-01.jpg",
    title: "Cloud kitchen packaging",
    altText: "Takeaway food packaging with South Indian breakfast items",
    caption: "",
    folder: "listings",
    mime: "image/jpeg",
    size: "301 KB",
    sizeBytes: 308224,
    width: 800,
    height: 600,
    source: "owner",
    uploader: "Demo Owner",
    createdAt: "2026-08-18T07:55:00.000Z",
    updatedAt: "2026-08-18T07:55:00.000Z",
  },
  {
    id: "14",
    url: "https://readdy.ai/api/search-image?query=Serene%20modern%20beauty%20salon%20and%20spa%20interior%20with%20styling%20chairs%20mirrors%20and%20warm%20ambient%20lighting%2C%20clean%20minimal%20background%2C%20calm%20wellness%20interior%20photography&width=800&height=600&seq=myyp-biz-20&orientation=landscape",
    fileName: "nandi-beauty-interior.jpg",
    originalName: "studio-03.jpg",
    title: "Nandi Beauty Studio — interior",
    altText: "Modern beauty salon and spa interior with warm ambient lighting",
    caption: "Pending moderation for the beauty listing gallery.",
    folder: "reviews",
    mime: "image/jpeg",
    size: "377 KB",
    sizeBytes: 386048,
    width: 800,
    height: 600,
    source: "owner",
    uploader: "Demo Owner",
    createdAt: "2026-08-14T16:20:00.000Z",
    updatedAt: "2026-08-14T16:20:00.000Z",
  },
  {
    id: "15",
    url: "https://readdy.ai/api/search-image?query=Elegant%20gold%20jewellery%20display%20on%20warm%20velvet%20with%20soft%20studio%20lighting%2C%20necklace%20and%20bangles%2C%20luxury%20retail%20photography%2C%20golden%20tones&width=800&height=600&seq=myyp-biz-8&orientation=landscape",
    fileName: "lakshmi-gold-display.jpg",
    originalName: "gold-display.jpg",
    title: "Gold jewellery display",
    altText: "Gold necklace and bangles displayed on warm velvet",
    caption: "",
    folder: "listings",
    mime: "image/jpeg",
    size: "455 KB",
    sizeBytes: 465920,
    width: 800,
    height: 600,
    source: "admin",
    uploader: "Administrator",
    createdAt: "2026-08-10T13:35:00.000Z",
    updatedAt: "2026-08-10T13:35:00.000Z",
  },
  {
    id: "16",
    url: "https://readdy.ai/api/search-image?query=Safari%20jeep%20on%20a%20forest%20trail%20at%20golden%20hour%20in%20Bandipur%20with%20tall%20trees%20and%20warm%20dust%20light%2C%20travel%20adventure%20photography&width=800&height=600&seq=myyp-biz-9&orientation=landscape",
    fileName: "bandipur-safari-jeep.jpg",
    originalName: "safari-jeep.jpg",
    title: "Bandipur safari jeep",
    altText: "Safari jeep on a forest trail in Bandipur at golden hour",
    caption: "",
    folder: "listings",
    mime: "image/jpeg",
    size: "468 KB",
    sizeBytes: 479232,
    width: 800,
    height: 600,
    source: "admin",
    uploader: "Administrator",
    createdAt: "2026-08-06T09:05:00.000Z",
    updatedAt: "2026-08-06T09:05:00.000Z",
  },
  {
    id: "17",
    url: "https://readdy.ai/api/search-image?query=Bright%20modern%20neighbourhood%20supermarket%20aisle%20with%20neatly%20stacked%20fresh%20produce%20and%20packaged%20groceries%20on%20clean%20shelves%2C%20warm%20soft%20lighting%2C%20simple%20uncluttered%20retail%20interior%20photography&width=800&height=600&seq=myyp-biz-14&orientation=landscape",
    fileName: "fresh-mart-aisle.jpg",
    originalName: "aisle.jpg",
    title: "Fresh Mart — produce aisle",
    altText: "Supermarket aisle with fresh produce and packaged groceries",
    caption: "",
    folder: "listings",
    mime: "image/jpeg",
    size: "402 KB",
    sizeBytes: 411648,
    width: 800,
    height: 600,
    source: "admin",
    uploader: "Administrator",
    createdAt: "2026-08-02T11:10:00.000Z",
    updatedAt: "2026-08-02T11:10:00.000Z",
  },
  {
    id: "18",
    url: "https://readdy.ai/api/search-image?query=Close%20up%20of%20filter%20coffee%20being%20poured%20into%20a%20steel%20tumbler%20at%20a%20traditional%20Indian%20restaurant%2C%20warm%20steam%20and%20golden%20light%2C%20food%20photography&width=800&height=600&seq=myyp-owner-media-6&orientation=landscape",
    fileName: "filter-coffee.jpg",
    originalName: "coffee-pour.jpg",
    title: "Filter coffee pour",
    altText: "Filter coffee poured into a steel tumbler",
    caption: "Owner upload used in the Mylari Mane gallery.",
    folder: "library",
    mime: "image/jpeg",
    size: "276 KB",
    sizeBytes: 282624,
    width: 800,
    height: 600,
    source: "owner",
    uploader: "Demo Owner",
    createdAt: "2026-07-28T08:45:00.000Z",
    updatedAt: "2026-07-28T08:45:00.000Z",
  },
];